import { api, apiPaths } from "../api";

export const removeAuction = async (id: number) => {
  await api
    .url(`${apiPaths.AUCTIONS}/${id}`)
    .delete()
    .json()
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.log("Received error", error.response?.errorType);
      // Re-throw the error so callers can handle it
      throw error;
    });
};
